export interface Skill {
  icon: string;
  label: string;
}

export interface SkillGroup {
  title: string;
  skills: Skill[];
  hasBorder?: boolean;
}

export interface SkillSection {
  title: string;
  skillGroups: SkillGroup[];
}

export interface SocialLink {
  href: string;
  icon: string;
  ariaLabel: string;
  title: string;
  hoverColor?: string;
}

export interface PersonalInfo {
  name: string;
  title: string;
}

export const portfolioData = {
  personalInfo: {
    name: "Christopher Maugis",
    title: "Développeur web fullstack"
  },

  socialLinks: [
    {
      href: "https://www.linkedin.com/in/christophermaugis",
      icon: "linkedin",
      ariaLabel: "Visiter mon profil LinkedIn",
      title: "Visiter mon profil LinkedIn",
      hoverColor: "hover:text-[#0A66C2]"
    },
    {
      href: "https://github.com/Dev0ph3r",
      icon: "github",
      ariaLabel: "Visiter mon profil Github",
      title: "Visiter mon profil Github"
    }
  ],

  skillSections: [
    {
      title: "Frontend",
      skillGroups: [
        {
          title: "Stack React",
          skills: [
            { icon: "react", label: "React" },
            { icon: "next-dot-js", label: "Next.js" },
            { icon: "npm", label: "npm" },
            { icon: "yarn", label: "yarn" }
          ],
          hasBorder: true
        },
        {
          title: "Langages",
          skills: [
            { icon: "javascript", label: "JavaScript" },
            { icon: "typescript", label: "TypeScript" },
            { icon: "html5", label: "HTML5" },
            { icon: "css3", label: "CSS3" }
          ],
          hasBorder: true
        },
        {
          title: "Webdesign",
          skills: [
            { icon: "tailwindcss", label: "Tailwind" },
            { icon: "bootstrap", label: "Bootstrap" },
            { icon: "sass", label: "Sass" },
            { icon: "material-ui", label: "Material UI" }
          ]
        }
      ]
    },
    {
      title: "Backend",
      skillGroups: [
        {
          title: "Stack PHP",
          skills: [
            { icon: "symfony", label: "Symfony" },
            { icon: "php", label: "PHP" },
            { icon: "twig", label: "Twig" },
            { icon: "composer", label: "Composer" }
          ],
          hasBorder: true
        },
        {
          title: "Stockage & Data",
          skills: [
            { icon: "mysql", label: "MySQL" },
            { icon: "postgresql", label: "PostgreSQL" },
            { icon: "redis", label: "Redis" },
            { icon: "aws", label: "AWS S3" }
          ],
          hasBorder: true
        },
        {
          title: "API & Services",
          skills: [
            { icon: "docker", label: "Docker" },
            { icon: "algolia", label: "Algolia" },
            { icon: "aws-lambda", label: "AWS Lambda" },
            { icon: "cloudflare", label: "Cloudflare" }
          ]
        }
      ]
    },
    {
      title: "Workflow",
      skillGroups: [
        {
          title: "Déploiement",
          skills: [
            { icon: "github", label: "GitHub" },
            { icon: "gitlab", label: "GitLab" },
            { icon: "github", label: "Actions" },
            { icon: "jenkins", label: "Jenkins" }
          ],
          hasBorder: true
        },
        {
          title: "Monitoring",
          skills: [
            { icon: "raygun", label: "Raygun" },
            { icon: "speedcurve", label: "Speedcurve" },
            { icon: "sentry", label: "Sentry" },
            { icon: "aws", label: "CloudWatch" }
          ],
          hasBorder: true
        },
        {
          title: "Organisation",
          skills: [
            { icon: "jira", label: "Jira" },
            { icon: "confluence", label: "Confluence" },
            { icon: "notion", label: "Notion" },
            { icon: "slack", label: "Slack" }
          ]
        }
      ]
    }
  ]
};